import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ToastContainer } from 'react-toastify'; // Import ToastContainer
import { Bars3Icon } from '@heroicons/react/24/outline';

const Backend: React.FC = () => {

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [selectedView, setSelectedView] = useState(() => {
    return localStorage.getItem('selectedView') || 'flow';
  });

  // Update localStorage whenever selectedView changes
  useEffect(() => {
    localStorage.setItem('selectedView', selectedView);
  }, [selectedView]);

  const handleViewChange = (view: React.SetStateAction<string>) => {
    setSelectedView(view);
  };

  const FNNlogo = require('../../img/FNNLogoWithWhiteFont-07.png');

  return (
    <div className="AppBackend backend">
      <ToastContainer /> {/* Handle toasts in this page */}
      <header className="flex items-center justify-between px-5 header flex-wrap">
        {/* App Logo - left */}
        <a href="/" className="logo-container">
          <img src={FNNlogo} className="App-logo" alt="FNN logo" />
        </a>

        {/* Center Nav - only on desktop */}
        <div className="desktop-nav hidden sm:!flex absolute left-1/2 transform -translate-x-1/2">
          <button
            className={`bnt-header ${selectedView === 'map' ? 'active' : ''}`}
            onClick={() => handleViewChange('map')}
          >
            Map
          </button>
          <button
            className={`bnt-header ${
              selectedView === 'report' ? 'active' : ''
            }`}
            onClick={() => handleViewChange('report')}
          >
            Report
          </button>
          <button
            className={`bnt-header ${
              selectedView === 'fnnTool' ? 'active' : ''
            }`}
            onClick={() => handleViewChange('fnnTool')}
          >
            Tools
          </button>
          <button
            className={`bnt-header ${selectedView === 'eff' ? 'active' : ''}`}
            onClick={() => handleViewChange('eff')}
          >
            Efficiency
          </button>
          <button
            className={`bnt-header ${selectedView === 'firereport' ? 'active' : ''}`}
            onClick={() => handleViewChange('firereport')}
          >
            Fire Report
          </button>

          <button
            className={`bnt-header ${selectedView === 'plot' ? 'active' : ''}`}
            onClick={() => handleViewChange('plot')}
          >
            Plot
          </button>
          <button
            className={`bnt-header ${selectedView === 'flow' ? 'active' : ''}`}
            onClick={() => handleViewChange('flow')}
          >
            Flow Chart
          </button>
        </div>

        {/* User Icon - right */}
        <div
          className="user-icon2 mr-3 flex gap-0 flex-col items-center text-base text-gray-400 hover:text-white cursor-pointer"
        >
          <svg
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '25px', height: '25px' }}
          >
            <g id="SVGRepo_iconCarrier">
              <path
                d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
                fill="#28aae1"
              />
              <path
                d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z"
                fill="#28aae1"
              />
            </g>
          </svg>
          {'gigi'}
        </div>

        {/* Menu Icon */}
        <div
          className="fnn-backend-icon-bg sm:hidden h-10 w-10 flex justify-center items-center responsive-margin"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <Bars3Icon className="fnn-backend-icon text-white" />
        </div>
      </header>
      
      
    </div>
  );
};

export default Backend;